require('./expensesByCategoryMonthly.scss');

//@vendors
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;

// @components
import OKTooltip from 'components/commons/OKTooltip/OKTooltip';
import { OneLineSymbolAmount } from 'commonsComponents/oneLineSymbolAmount';
import { OKBoxSectionContent } from 'commonsComponents/OKBoxSectionContent';
import { OKLoadingErrorMessage } from "commonsComponents/OKLoadingErrorMessage";
import MonthlyChart from "./monthlyChart/monthlyChart";

// @actions
import { requestMonthly } from 'actions/expensesByCategories/expensesByCategoriesMonthly';

class ExpensesByCategoryMonthly extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { requestMonthly, getFilterObject } = this.props;
        const filtersObject = getFilterObject ? getFilterObject() : {};

        requestMonthly(filtersObject);
    }

    buildTitleBoxSection = () => {
        return (
            <FormattedText value="monthlyExpenses-title" />
        )
    }

    buildSubTitleBoxSection = () => {
        const currentMonth =  moment().format('MMMM');
        const currentDay = moment().format('DD');

        return (
            formatText('monthlyExpenses-date', [currentDay,currentMonth])
        )
    }

    buildMonthlyChart = () => {
        return (
            <div className="monthly-chart">
                <div className="monthly-chart__sector">{}</div>
                <div className="monthly-chart__sector">{}</div>
                <div className="monthly-chart__sector">{}</div>
            </div>
        )
    }

    buildContent = () => {
        const { fetching, fetchingTotalized, error, errorTotalized, monthlyValue, monthlyValueTotalized, currency } = this.props;
        let message = "lessMessage";

        if (-0.5 < monthlyValue)
            message = monthlyValue >= 0.5 ? 'moreMessage' : 'sameMessage' ;

        return (
            <div className="expenses-by-category-monthly">
                <OKLoadingErrorMessage
                    isLoading={fetching || fetchingTotalized}
                    isError={error || errorTotalized}
                >
                    <div className="expenses-by-category-monthly__total-title">
                        <FormattedText value="monthlyExpenses-total" />
                        <div className="expenses-by-category-monthly__total-title__monto">
                            <OneLineSymbolAmount
                                language={getLanguage()}
                                positiveAmount
                                amountObject={
                                    {
                                        amount: monthlyValueTotalized ? monthlyValueTotalized.get('data') : 0, 
                                        currencySymbol: currency}}
                                amountObjectFormatted={{currencySymbol: currency}}
                            />
                        </div>
                    </div>
                    <div>
                        <div className="expenses-by-category-monthly__total-chart">
                            <MonthlyChart
                                monthlyValue={monthlyValue}
                            />
                        </div>
                        <div className="expenses-by-category-monthly__total-chart-info">
                            <FormattedText value={`monthlyExpenses-${message}`} />
                            <OKTooltip
                                content="monthlyExpenses-textTooltip"
                                modifier="dark-bg"
                                offset={[-70, 10]}
                                placement="bottom"
                            />
                        </div>
                        <ul className="expenses-by-category-monthly__total-chart-legend">
                            <li className="expenses-by-category-monthly__total-chart-legend__good-status">
                                <FormattedText value="monthlyExpenses-legendGood" />
                            </li>
                            <li className="expenses-by-category-monthly__total-chart-legend__same-status">
                                <FormattedText value="monthlyExpenses-legendSame" />
                            </li>
                            <li className="expenses-by-category-monthly__total-chart-legend__bad-status">
                                <FormattedText value="monthlyExpenses-legendBad" />
                            </li>
                        </ul>
                    </div>
                </OKLoadingErrorMessage>
            </div>
        )
    }

    render() {
        return (
            <section className="col-lg-4 col-md-12 col-sm-12">
                <div className="expenses-by-category__monthly-container">
                    <OKBoxSectionContent
                        title={this.buildTitleBoxSection()}
                        darkStyle
                        subTitle={this.buildSubTitleBoxSection()}
                        content={
                            this.buildContent()
                        }
                    />
                </div>
            </section>
        );
    }
}

ExpensesByCategoryMonthly.propTypes = {
    error: PropTypes.bool,
    fetching: PropTypes.bool,
    monthlyValue: PropTypes.number,
    requestMonthly: PropTypes.func,
    totalAmount: PropTypes.number,
    errorTotalized: PropTypes.bool,
    fetchingTotalized: PropTypes.bool,
    monthlyValueTotalized: PropTypes.object,
    currency: PropTypes.string,
    getFilterObject: PropTypes.func,
};

module.exports.ExpensesByCategoryMonthly = connect(
    state => ({
        immAggregatorData: state.aggregatorData,
        monthlyValue: state.expensesByCategoriesMonthly.get('monthlyValue'),
        fetching: state.expensesByCategoriesMonthly.get('fetching'),
        error: state.expensesByCategoriesMonthly.get('error'),
        monthlyValueTotalized: state.expensesByCategoriesMonthly.get('monthlyValueTotalized'),
        fetchingTotalized: state.expensesByCategoriesMonthly.get('fetchingTotalized'),
        errorTotalized: state.expensesByCategoriesMonthly.get('errorTotalized'),
    }),
    {
        requestMonthly
    }
)(ExpensesByCategoryMonthly);